import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';
import classNames from 'classnames';

import messages from './messages';
import { ISubpageRenderProps } from './SubPageController';
import Button, { ButtonType } from '../../components/button/button';
import ProgressIndicator from '../../components/progress-indicator/progress-indicator';

const SubPageNavigator: React.SFC<RouteProps & ISubpageRenderProps> = ({
  index,
  total,
  currentRouteIsValid,
  handlePrev,
  handleNext
}) => (
  <div className={classNames('c-bubble__nav-start')}>
    {index != 0 && (
      <Button type={ButtonType.circlePrev} onClick={() => handlePrev()}>
        <FormattedMessage {...messages.previous} />
      </Button>
    )}
    {index == 0 && (
      <Button type={ButtonType.circlePlaceholder} onClick={() => handlePrev()}>
        <FormattedMessage {...messages.previous} />
      </Button>
    )}

    <ProgressIndicator index={index} total={total} />
    <Button
      type={index + 1 === total ? ButtonType.circleDone : ButtonType.circleNext}
      onClick={() => handleNext()}
      disabled={!currentRouteIsValid}
    >
      <FormattedMessage {...messages.next} />
    </Button>
  </div>
);

export default SubPageNavigator;



// WEBPACK FOOTER //
// ./src/containers/components/SubPageNavigator.tsx